'use client';
import React from 'react';
import { Tooltip } from 'react-tooltip';
import HelpIcon from '../Icons/Help';

const CINTooltip = ({ description }: { description: string }) => {
  return (
    <>
      <Tooltip id="cin-tooltip" place="top">
        <p>{description}</p>
      </Tooltip>
      <HelpIcon
        id="cin-tooltip"
        className="w-5 h-5 fill-current text-gray-300"
      />
    </>
  );
};

export default CINTooltip;
